const BASE_URL =
    (process.env.REACT_APP_API_ROOT_LMS || process.env.REACT_APP_API_ROOT_DEFAULT) + '/lms/';

export const urls = {
    dashboard_summary: BASE_URL + 'dashboard/summary/',
    dashboard_report: BASE_URL + 'dashboard/reports/',

    accounts: BASE_URL + 'accounts/',
    accounts_bulk_create: BASE_URL + 'accounts/bulk_create/',
    accounts_bulk_update: BASE_URL + 'accounts/bulk_update/',
    accounts_download_excel: BASE_URL + 'accounts/download_excel/',
    account_details: BASE_URL + 'accounts/:id/',
    account_activate: BASE_URL + 'accounts/:id/active/',
    account_deactivate: BASE_URL + 'accounts/:id/inactive/',

    borrower_details: BASE_URL + 'borrowers/:id/',

    line_detail: BASE_URL + 'line_detail/:id/',
    loan_data: BASE_URL + 'loan_data/:id/',

    loans: BASE_URL + 'loans/',
    overdue_loans: BASE_URL + 'loans/overdue/',

    topups: BASE_URL + 'topups/',
    topups_summary: BASE_URL + 'topups/summary/',
    topups_bulk_create: BASE_URL + 'topups/bulk_create/',
    topups_download_excel: BASE_URL + 'topups/export/',
    topup_details: BASE_URL + 'topups/:id/',
    topup_tranches: BASE_URL + 'topups/:id/tranches/',
    topup_groups: BASE_URL + 'topups_groups/',
    approve_topup: BASE_URL + 'topups/:id/approve/',
    reject_topup: BASE_URL + 'topups/:id/reject/',
    archive_topup: BASE_URL + 'topups/:id/archive/',
    hold_topup: BASE_URL + 'topups/:id/hold/',
    unhold_topup: BASE_URL + 'topups/:id/unhold/',
    disburse_topup: BASE_URL + 'topups/:id/disburse/',
    schedule_topup: BASE_URL + 'topups/:id/schedule/',
    unschedule_topup: BASE_URL + 'topups/:id/unschedule/',

    topup_run_checks: BASE_URL + 'topups/run_checks/',
    upload_invoice_zip: BASE_URL + 'topups/upload_invoice_zip/',
    invoice_uploads: BASE_URL + 'invoice_uploads/',
    invoice_uploads_rerun: BASE_URL + 'invoice_uploads/:id/rerun/',
    invoice_uploads_details: BASE_URL + 'invoice_uploads/:id/',

    approvals: BASE_URL + 'approvals/',
    approval_details: BASE_URL + 'approvals/:id/',

    payouts: BASE_URL + 'payouts/',
    payouts_add_tranche: BASE_URL + 'payouts/add_tranche/',
    payouts_unmatched: BASE_URL + 'payouts/unmatched/',
    payouts_bulk_create: BASE_URL + 'payouts/bulk_update/',
    payouts_download_excel: BASE_URL + 'payouts/download_excel/',
    payouts_export_excel: BASE_URL + 'payouts/export_excel/',
    payout_send_to_bank: BASE_URL + 'payouts/send_to_bank/',

    payout_details: BASE_URL + 'payouts/:id/',
    payout_mark_processed: BASE_URL + 'payouts/:id/mark_processed/',
    payout_mark_failed: BASE_URL + 'payouts/:id/mark_failed/',

    // payout batch
    payout_batches: BASE_URL + 'payouts-batches/',
    payout_batches_send_payout_batch: BASE_URL + 'payouts-batches/send_payout_batch/',
    payout_batches_mark_processed: BASE_URL + 'payouts-batches/:id/mark_processed/',
    payout_batches_mark_failed: BASE_URL + 'payouts-batches/:id/mark_failed/',
    payout_batches_retry: BASE_URL + 'payouts-batches/retry/',
    payout_batches_reprocess: BASE_URL + 'payouts-batches/:id/re-process/',

    tasks: BASE_URL + 'tasks/',
    task_details: BASE_URL + 'tasks/:id/',
};
